import React, { useState } from 'react';
import { Phone, Mail, Instagram, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      {/* Top bar */}
      <div className="bg-black text-white py-2">
        <div className="container mx-auto px-4 flex flex-wrap justify-between items-center text-sm">
          <div className="flex items-center gap-4 flex-wrap">
            <a href={`tel:${companyInfo.phone.replace(/\D/g, '')}`} className="flex items-center gap-2 hover:text-red-500 transition-colors">
              <Phone size={14} />
              <span>{companyInfo.phone}</span>
            </a>
            <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 hover:text-red-500 transition-colors">
              <Mail size={14} />
              <span className="hidden sm:inline">{companyInfo.email}</span>
            </a>
          </div>
          <a 
            href={companyInfo.instagramUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-red-500 transition-colors"
          >
            <Instagram size={14} />
            <span>@{companyInfo.instagram}</span>
          </a>
        </div>
      </div>

      {/* Main navigation */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img 
              src={companyInfo.logo} 
              alt="Expert Roofing Logo" 
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('before-after')} className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Before & After
            </button>
            <button onClick={() => scrollToSection('portfolio')} className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Portfolio
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-red-600 hover:bg-red-700 text-white px-6"
            >
              Free Estimate
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden text-black"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-3">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-red-600 transition-colors font-medium text-left py-2">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-red-600 transition-colors font-medium text-left py-2">
              Services
            </button>
            <button onClick={() => scrollToSection('before-after')} className="text-gray-700 hover:text-red-600 transition-colors font-medium text-left py-2">
              Before & After
            </button>
            <button onClick={() => scrollToSection('portfolio')} className="text-gray-700 hover:text-red-600 transition-colors font-medium text-left py-2">
              Portfolio
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-red-600 transition-colors font-medium text-left py-2">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-red-600 transition-colors font-medium text-left py-2">
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-red-600 hover:bg-red-700 text-white w-full"
            >
              Free Estimate
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
